var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "app"
  }, [_c('seu-main-header', {
    on: {
      "selectLanguage": _vm.selectLanguage
    }
  }), _c('seu-header-mobile', {
    attrs: {
      "menu-opened": _vm.menuOpened
    },
    on: {
      "openMenu": function ($event) {
        _vm.menuOpened = true;
      },
      "closeMenu": function ($event) {
        _vm.menuOpened = false;
      }
    }
  }), _c('Transition', {
    attrs: {
      "name": "mobile-menu"
    }
  }, [_vm.menuOpened ? _c('mobile-menu', {
    attrs: {
      "menu-opened": _vm.menuOpened,
      "c": ""
    },
    on: {
      "closeMenu": function ($event) {
        _vm.menuOpened = false;
      },
      "selectLanguage": _vm.selectLanguage,
      "openPopup": _vm.openPopup
    }
  }) : _vm._e()], 1), _c('router-view', {
    on: {
      "openPopup": _vm.openPopup
    }
  }), _c('footer-section', {
    on: {
      "openPopup": _vm.openPopup
    }
  }), _c('vi-popup', {
    attrs: {
      "popup-class": _vm.popup === 'TERMS' ? 'popup-wide' : ''
    },
    model: {
      value: _vm.showPopup,
      callback: function ($$v) {
        _vm.showPopup = $$v;
      },
      expression: "showPopup"
    }
  }, [_vm.popup === 'ARRIVAL' ? _c('arrival') : _vm.popup === 'MEDIA' ? _c('media') : _vm.popup === 'NEWSLETTER' ? _c('newsletter', {
    on: {
      "subscribed": function ($event) {
        _vm.showPopup = false;
      }
    }
  }) : _vm.popup === 'JOBS' ? _c('jobs') : _vm.popup === 'IMPRESSUM' ? _c('impressum') : _vm.popup === 'TERMS' ? _c('terms', {
    attrs: {
      "fields": _vm.termsContent.sections.cookies_banner_section.fields
    }
  }) : _vm._e()], 1), _c('cookies-banner', {
    attrs: {
      "fields": _vm.cookiesBannerContent.sections.cookies_banner_section.fields
    },
    on: {
      "openPolicyPopup": function ($event) {
        return _vm.openPopup('TERMS');
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }